import { render, staticRenderFns } from "./5-onboarding.vue?vue&type=template&id=580368db&scoped=true&"
import script from "./5-onboarding.vue?vue&type=script&lang=js&"
export * from "./5-onboarding.vue?vue&type=script&lang=js&"
import style0 from "./5-onboarding.vue?vue&type=style&index=0&id=580368db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580368db",
  null
  
)

export default component.exports